import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export const IconEditPencilFilled = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 18 19" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.1792 4.10612C10.96 3.32419 12.2258 3.32323 13.0066 4.10398L14.1737 5.27109C14.9478 6.04517 14.9554 7.29881 14.1907 8.08337L13.4221 8.87191L9.41837 4.86815L10.1792 4.10612ZM8.35811 5.93001L12.3747 9.94659L7.83263 14.6068C7.26771 15.1864 6.49299 15.5132 5.68424 15.5132L4.32663 15.5132C3.47425 15.5131 2.79387 14.8029 2.82972 13.9506L2.88963 12.5263C2.92125 11.7747 3.23378 11.0621 3.76532 10.5298L8.35811 5.93001ZM15.386 16.2087C15.8001 16.2087 16.1357 15.8728 16.1357 15.4584C16.1357 15.044 15.8001 14.7081 15.386 14.7081H10.7947C10.3807 14.7081 10.045 15.044 10.045 15.4584C10.045 15.8728 10.3807 16.2087 10.7947 16.2087H15.386Z"
      fill="currentColor"
    />
  </SvgIcon>
)
